import { ClubApi } from 'api'
import { withErrorBoundary, connected, SearchBar } from 'shared'
import { TopLevelPage, ModelGrid } from 'ui'
import { SmartButtonFeedList } from 'ui/smart-buttons'

class Clubs extends Component {
  static propTypes = {
    match: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.query = ClubApi.paramsFor('index').q
  }

  render() {
    let { id, eventId } = this.props.match.params
    let models = ClubApi.kick('index', { q: this.query })

    return (
      <TopLevelPage className="Parks" modelId={eventId || id} base={eventId ? `/clubs/${id}` : '/clubs'}>
        <div className="row">
          <div className="col-sm-6 col-lg-4 col-xl-3">
            <SearchBar onChange={this.queryDidChange} onSubmit={this.queryWouldSubmit} initialQuery={this.query} />
          </div>
        </div>
        <ModelGrid models={models} base={'clubs'} />
        {App.showsButtonsOnEachFeed && <SmartButtonFeedList base='/clubs' />}
      </TopLevelPage>
    )
  }

  queryDidChange = query => { this.query = query }
  queryWouldSubmit = () => { this.forceUpdate() }
}

export default withErrorBoundary(connected(Clubs))
